module.exports = __webpack_public_path__ + "img/strength-safety.ca90907a.png";